<footer class="wk-footer" style="margin-top:100px">
  <div class="pre-footer">
    <a href="https://www.regione.puglia.it/valuta-questo-sito" class="pre-footer">Valuta questo sito</a>
  </div>
  <div class="wk-footer-content">
    <div class="container">
      <div class="row">
        <div class="col-md-4 ps-0">
          <div class="wk-image-logo"
            style="background-image: url(assets/img/logoregionepuglia.png); width:101px; height:48px;"></div>
          <span class="footer-title">Contatti e indirizzi</span>
          <span class="contatti">Lungomare N. Sauro, 33 - 70121 Bari</span>
          <span class="display-block">Telefono: 800 713939</span>
          <span class="display-block mb-14" style="margin-bottom:14px">E-mail: <a class="link-email"
              href="mailto:quiregione@regione.puglia.it" target="_blank">quiregione@regione.puglia.it</a></span>
        </div>
        <div class="col-md-8 px-0" style="padding:0px;">
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between border-bottom">
                <span class="area mb-23" style="margin-bottom:23px" *ngIf="!isLoggedIn">
                  <img class="mr-14" style="margin-right:14px" src="assets/svg/Shape.svg">
                  <span style="cursor: pointer;" (click)="login()">Area riservata</span>
                </span>
                <span class="area mb-23" style="margin-bottom:23px" *ngIf="isLoggedIn">
                  <img class="mr-14" style="margin-right:14px" src="assets/svg/Shape.svg">
                  <span style="cursor: pointer;" (click)="logout()">Logout</span>
                </span>
                <span class="d-flex justify-content-between" style="margin-bottom:16px">
                  <a class="mr-8" style="margin-right:8px" href="https://www.facebook.com/quiregionepuglia/"><img
                      src="assets/svg/facebook.svg"></a>
                  <a class="mr-8" style="margin-right:8px" href="https://twitter.com/RegionePuglia"><img
                      src="assets/svg/twitter.svg"></a>
                  <a class="mr-8" style="margin-right:8px" href="https://www.youtube.com/user/comunicazioneist"><img
                      src="assets/svg/youtube.svg"></a>
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <ul class="wk-footer">
                <li>
                  <a href="https://trasparenza.regione.puglia.it/responsabile-della-trasparenza"
                    class="linkText">Responsabile della trasparenza</a>
                </li>
              </ul>
            </div>
            <div class="col-md-6 ">
              <span class="title footer-title-2">Accessibilità</span>
              <ul class="wk-footer">
                <li class="mb-64" style="margin-right:64px">
                  <a href="https://form.agid.gov.it/view/b4a0da2e-432c-4e76-bcd9-55e1678fcc3e" class="linkText">
                    Dichiarazione di accessibilità</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="d-md-flex justify-content-between align-item-center footer-bottom">
          <span>
            <ul class="d-md-flex" role="group">
              <li class="list-inline-item">
                <a href="https://trasparenza.regione.puglia.it/note-legali" class="anchor-link footerLastLink">Note
                  legali</a>
              </li>
              <li class="list-inline-item">
                <a href="https://trasparenza.regione.puglia.it/cookie-e-privacy" class="anchor-link footerLastLink">
                  Cookie e privacy </a>
              </li>
            </ul>
          </span>
          <div class="d-md-flex justify-content-end copyright">
            <span>
              <a href="http://www.regione.puglia.it/">© Regione Puglia</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>